import { Space, Tag } from 'antd'
import React from 'react'

const TagGroup = ({ elements, color }) => {
  return (
    <Space style={{ display: 'flex', flexWrap: 'wrap' }}>
      {elements.map(name => (
        <Tag
          key={name}
          style={{ color, borderColor: color }}
        >
          {name}
        </Tag>
      ))}
    </Space>
  )
}

export default TagGroup
